import React from "react";
import "./HomeButton.css";

export default function HomeButton(props) {
    return (
        <>
            <button onClick={props.onClick}
                    className={"bg-white flex flex-row gap-5 font-bold shadow-[0px_4px_4px_0px_rgb(0,0,0,0.25)] " +
                        "hover:shadow-[0px_4px_4px_0px_rgb(0,0,0,0.5)] rounded-md px-5 py-2"}>
                <div
                    className={`my-auto ${props.isActive ? 'text-[#FFB800]' : 'text-[#7E8CA0]'}`}>
                    {props.children}
                </div>
                <p className={`my-auto ${props.isActive ? 'text-[#163579]' : 'text-[#7E8CA0]'}`}>
                    {props.name}
                </p>
            </button>
        </>
    );
}
